import type { ScreenSchema } from './types';

/**
 * Schema for the `quiz` template (screen-quiz.vue).
 *
 * `managesOwnSectionAudio: true` — the parent quiz uc-screen must NOT auto-play
 * its intro via the generic sectionActive watcher. screen-quiz.vue handles JiT audio
 * directly because the nested uc-scroll-sections it creates for each question are
 * inner (non-top-level) sections: their `sectionActive` is derived from
 * `currentSection === innerEl`, but the page navigation only promotes the *outer*
 * quiz scroll-section to currentSection when the quiz enters view. The inner
 * question sections only become currentSection as the user scrolls through them
 * individually, so the first question's watcher would never fire on initial entry.
 *
 * screen-quiz.vue therefore injects the outer sectionActive and plays the first
 * visible question's intro (JiT or S3 via resolveChildIntro) when the quiz
 * section activates. Subsequent questions play via each inner uc-screen's
 * sectionActive watcher as the user scrolls through the quiz.
 */
const quizSchema: ScreenSchema = {
  template: 'quiz',
  managesOwnSectionAudio: true,
  slots: {}
};

export default quizSchema;
